export type ClaimDefine = {
  claim: [
    {},
    {
      claim: {
        args: never;
        typeArgs: never;
      };
      getUserStats: {
        args: { user_addr: string };
        typeArgs: never;
      };
    },
  ];
};

export const ClaimIdl = {
  modules: [
    {
      name: 'claim',
      displayName: 'claim',
      methods: [
        {
          name: 'claim',
          displayName: 'claim',
          args: [],
          typeArgs: [],
        },
        {
          name: 'get_user_stats',
          displayName: 'getUserStats',
          args: [
            { name: 'user_addr', jsType: 'string', moveType: 'address' },
          ],
          typeArgs: [],
        },
      ],
      structs: [],
    },
  ],
};
